import React from 'react';
import './HostsGuestsTab.css';
import SocialUserCard from "../../../components/social/SocialUserCard";
import { useChatDock } from "../../../contexts/ChatDockContext";
import { useAuth } from '../../../contexts/authContext';
import { useNavigate } from "react-router-dom";

const HostsGuestsTab = ({ hosts = [], guests = [], attendees = [], loadingAttendees = false }) => {
  const { openChat } = useChatDock();
  const { user: currentUser } = useAuth();
  const navigate = useNavigate();

  const renderSocialUser = (person, badgeLabel) => {
    const displayName = person.display_name || person.name || 'Anonymous';
    const id = person.id || person.user_id;

    const userData = {
      ...person,
      id,
      display_name: displayName,
      // Use the same avatar_url shape as other sections (e.g. Birthdays/Discover)
      avatar_url: person.avatar_url || null,
    };

    const isSelf = currentUser && id === currentUser.id;
    const extraBadge = badgeLabel
      ? { label: badgeLabel, title: badgeLabel }
      : null;

    return (
      <SocialUserCard
        key={id}
        user={userData}
        isSelf={isSelf}
        canMessage={!isSelf}
        extraBadge={extraBadge}
        onClick={() => window.open(`/app/profile/${id}`, '_blank', 'noopener,noreferrer')}
        onMessage={() => openChat(id)}
        showHoverDetails
      />
    );
  };

  if (loadingAttendees) {
    return <div className="event-hosts-guests-tab"><p>Loading participants...</p></div>;
  }

  return (
    <div className="event-hosts-guests-tab">
      <div className="hosts-section">
        <h3>Hosts</h3>
        <div className="people-grid user-grid">
          {hosts.length ? (
            hosts.map(person => renderSocialUser(person, 'Host'))
          ) : <p>No hosts listed.</p>}
        </div>
      </div>
      
      <div className="guests-section">
        <h3>Special Guests</h3>
        <div className="people-grid user-grid">
          {guests.length ? (
            guests.map(person => renderSocialUser(person, 'Guest'))
          ) : <p>No special guests for this event.</p>}
        </div>
      </div>
      
      <div className="attendees-section">
        <h3>Attendees</h3>
        <div className="people-grid user-grid">
          {attendees.length ? (
            attendees
              .filter(a => a.role === 'going' || a.role === 'interested')
              .map(person => {
                const label = person.role === 'going' ? 'Going' : 'Interested';
                return renderSocialUser(person, label);
              })
          ) : <p>No attendees yet. Be the first to join!</p>}
        </div>
      </div>
    </div>
  );
};

export default HostsGuestsTab;